// removed by extract-text-webpack-plugin
module.exports = {"container":"wF13a"};


//////////////////
// WEBPACK FOOTER
// ./app/components/new-post-message/new-post-message.scss
// module id = 1559
// module chunks = 0